<template>
	<el-popover placement="bottom" title="列筛选" trigger="click" style="margin-left:0.625rem" @hide="hidePop">
		<el-checkbox-group v-model="checkedColumns" size="mini">
			<el-checkbox v-for="(item, index) in listColumns" :key="index" style="width:10rem;margin-bottom: 0.3125rem;"
				:label="item.label" :value="item.label" :disabled="item.isKeep"></el-checkbox>
		</el-checkbox-group>
		<el-button slot="reference" type="primary" size="small" plain><i
				class="el-icon-arrow-down el-icon-menu" />&nbsp;</el-button>
	</el-popover>
</template>

<script>
	export default {
		name: 'MyColumnFilter',
		props: {
			listColumns: {
				type: Array,
				default: () => [
					/* {
						prop: '', 			对应字段
						label: '', 			显示列名
						minWidth: '60',		最小宽度
						isKeep: true,		是否可勾选
						notDefault: true,	是否默认显示

					} */
				],
			}
		},
		data() {
			return {
				checkedColumns: []
			}
		},
		components: {},
		mounted() {
			// 初始勾选列
			this.checkedColumns = this.listColumns.filter(item => item.label && !item.notDefault).map(item => item.label)
			this.hidePop()
		},
		methods: {
			// 关闭筛选列
			hidePop() {
				this.$emit('hidePop', this.checkedColumns)
			},
		}
	}
</script>

<style scoped>
</style>